const enUS = {
  header: {
    about: 'About me',
    projects: 'Projects',
    contact: 'Contact',
  },
  hero: {
    greeting: "Hi, I'm",
    profession: 'Software Engineer.',
    seeMore: 'See more',
  },
  about: {
    sectionTag: 'about me',
    title: 'Crafting digital <span>experiences</span>.',
    bio: `My name is Leonardo — Leo for short. I started my journey in software development back in 2018, driven by curiosity and a genuine passion for building things that work beautifully.
    <br/><br/>
    I specialize in the JavaScript ecosystem, with deep experience in <strong>React.js</strong>, <strong>Node.js</strong>, and <strong>TypeScript</strong>. I care about clean architecture, maintainable code, and delivering real value — not just features.`,
    skillsTitle: 'tech stack',
    highlightYears: 'Years exp.',
    highlightProjects: 'Projects',
    highlightTech: 'Technologies',
  },
  projects: {
    title: 'Projects',
    comingSoon: 'Coming soon',
    seeGitHub: 'See repositories in GitHub',
  },
  contact: {
    title: 'Contact',
    sectionTag: 'contact',
    headline: "Let's build something <span>together</span>.",
    subtitle: "I'm always open to new opportunities, collaborations, or just a good conversation. Pick your preferred channel and let's talk.",
  },
}

export default enUS
